import {Selector} from '@ngxs/store';
import {UserSportsState, UserSportsStateModel} from './user-sports.state';

export class UserSportsSelector {
  @Selector([UserSportsState])
  static loading(state: UserSportsStateModel): boolean {
    return state.loading;
  }


}
